import { useMutation, useQuery } from '@tanstack/react-query';
import { getData, sendData } from '../fetchers';

export const useAdminAccessMutation = () =>
  useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      sendData('admin/access', data, params, queryParams),
  });

export const useVerifyAdminQuery = (params) =>
  useQuery({
    queryKey: ['verify-admin', params?.params, params?.queryParams],
    queryFn: () => getData('admin/verify', params?.params, params?.queryParams),
    // select: (data) => data?.data,
    retry: 1,
  });
